import { Box } from "@mui/material";
import type { PropsWithChildren } from "react";

export default function InfoIcon({ children }: PropsWithChildren) {
  return (
    <Box
      sx={{
        alignItems: "center",
        backgroundColor: "#f7f8fb",
        borderRadius: 2,
        color: "#7d8796",
        display: "flex",
        height: 32,
        justifyContent: "center",
        minWidth: 32,
        width: 32,
      }}
    >
      {children}
    </Box>
  );
}
